import type { Company } from '../../../domain/company';

export const isCompanyDataPresent = ({ domain, name, yearMonth }: Partial<Company>) =>
  Boolean(domain && (name || yearMonth));

export const sortCompaniesByName = (companies: Company[]) =>
  companies.sort((a, b) => (a.name ? (a.name > b.name ? 1 : -1) : 1));
